import angular from 'angular';

import routing from './compare-graph-index.routes';
import CompareBookmarkService from '../../../components/api/compare_bookmark/compare_bookmark.service';

import './compare-graph-index.css';

export class CompareGraphIndexController {
  /*@ngInject*/
  constructor($location, CompareBookmarkService) {
    this.$location = $location;
    this.CompareBookmarkService = CompareBookmarkService;
    this.bookmarks = [];
  }

  $onInit() {
    this.CompareBookmarkService.index(res => {
      this.bookmarks = res;
    });
  }

  goCompareGraph(bookmark) {
    this.$location.url(`compare/${bookmark.query}`);
  }
}

export default angular.module('leptonApp.compareGraphIndex', [CompareBookmarkService])
  .config(routing)
  .component('compareGraphIndex', {
    template: require('./compare-graph-index.html'),
    controller: CompareGraphIndexController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/compare-graph/index/compare-graph-index.component.js